module.exports = __webpack_public_path__ + "img/menuIcon14.042e9744.png";